export class Constant {

    public static GoCardLessSuccessStatus: number = 1;
    public static GoCardLessInfoStatus: number = 2;
    public static GoCardLessErrorStatus: number = 3;
    public static FeaturedJobsId: number = 17;
    public static AutoSearchId: number = 26;
    public static PreCVSerach4uId: number = 56;
    public static MultipostId: number = 18;
    public static Apply4U = "Apply4U";
    public static Apply4ULogoUrl = "assets/images/New_Apply4U_Logo.webp";
}

export const DefaultPageNumber = 1;
export const DefaultPageSize = 15;
export const DefaultRadius = 20;
export const JobDefaultRadius = 15;
export const JobNearMeDefaultRadius = 5;
export const DefaultSearchWithIn = 30;
export const Relevancy = "Relevancy";
export const DatePosted = "Date";
export const Apply4ULogoUrl = "assets/images/New_Apply4U_Logo.webp";
export const Apply4U = "Apply4U";
export const ExclusiveCVDownloadMessage: string = "This candidate is currently working exclusively with Harrisons Recruitment, should you be interested in the profile, please contact Harrisons Recruitment on 0203 994 5538 or info@harrisonsrecruitment.com to discuss further.";
export const SomethingWentWrong = "Something went wrong. Please try again or contact Help Desk at info@apply4u.co.uk";
export const  SignInToDownloadCV= "Sign in to download CV";
export const InvalidCandidateType = "Invalid Candidate Type";
export const SelectPlease = "selectPlease";
export const SelectSubPlease = "selectSubPlease";
export const BreadCrumbTitleHome = "Home";
export const BreadCrumbTitleDashBoard = "Dashboard";
export const BreadCrumbTitleBrowseJobs = "Browse Jobs";
export const BreadCrumbTitleBrowseCVs = "Browse CVs";
export const BreadCrumbTitleHiddenJobs = "Hidden Jobs";
export const BreadCrumbTitleHiddenCVs = "Hidden CVs";
export const BreadCrumbTitleJobShortList = "Job ShortList";
export const BreadCrumbTitleMyConnections = "My Connections";
export const BreadCrumbTitleConnectionsRequest = "Connections Request";
export const BreadCrumbTitlePendingRequest = "Pending Request";
export const BreadCrumbTitleSuggestedConnections = "Suggested Connections";
export const BreadCrumbTitleGroupJoinRequest = "Group Join Request";
export const BreadCrumbTitleGroupJoinInvite = "Group Join Invite";
export const BreadCrumbTitleRejectedRequests = "Rejected Requests";
export const BreadCrumbTitleRecommendedJobsAndCompanies = "Recommended Jobs and Companies";
export const BreadCrumbTitleRecommendedCVs = "Recommended CVs";
export const BreadCrumbTitleMyAutoSearch = "My Auto Search";
export const BreadCrumbTitleJobsAllLocation = "Jobs by all locations";
export const BreadCrumbTitleCVsAllLocation = "CVs by all locations";
export const BreadCrumbTitleCVsAllIndustries = "CVs by all industries";
export const BreadCrumbTitlePopularCVS = "all popular CVs";
export const BreadCrumbTitleWorkFromHome = "Work from home";
export const CVsNearMeBreadCrumbTitle = "CVs near me";
export const JobsNearMeBreadCrumbTitle = "Jobs near me";
export const BreadcrumbsTitleAccountSettings = "Account Settings";
export const BreadcrumbsTitleManageAlerts = "Manage Alerts";
export const BreadcrumbsTitleRecentApplication = "Recent Applications";
export const BreadcrumbsTitleCVsShortlist = "CVs Shortlist";
export const BreadcrumbsTitleCVsSearch4U = "Search4Me";
export const BreadcrumbsTitlePostJob = "Post Job";
export const BreadcrumbsTitleManageJobs = "My Jobs";
export const BreadcrumbsTitleJobsAppliedFor = "My Applications";
export const BreadcrumbsTitleSearchJobs = "Search Jobs";
export const BreadcrumbsTitleSearchCVs = "Search CVs";
export const BreadcrumbsTitleAdvanceCVsSearch = "Advance CVs Search";
export const BreadcrumbsTitleAdvanceJobsSearch = "Advanced Job Search";
export const BreadcrumbsTitlePricing = "Pricing";
export const BreadcrumbsTitleMyPayment = "My Payment";
export const BreadcrumbsTitleMyCompany = "My Company";
export const BreadcrumbsTitleCompanyDirectory = "Company Directory";
export const BreadcrumbsTitleGroupAndForums = "Groups & Forum";
export const BreadcrumbsTitleBlogs = "Blogs";
export const BreadcrumbsTitleUserDirectory = "User Directory";
export const RecentApplicationNoApplicantsYet = "You have not received any application yet.";
export const RecentApplicationSelectJobTitle = "Please select a job title from the list to view applicants.";
export const RecentApplicationSPostedAnyJob = "You have not received any application yet.";
export const NoResumeFound ="No CV found.";

export const Verified = "Verified";
export const Employer = "Employer Verified";
export const Expert = "Expert Verified";
export const Alphabetically = "Alphabetically";
export const JobTypeAny = "1";
export const JobTypeContract = "2";
export const JobTypePermanent = "3";
export const JobTypeTemporary = "4";
export const JobTypeGarduateTrainee = "5";
export const JobTypeWorkFromHome = "6";
export const JobTypePartTime = "7";
